import React from 'react';

import { LazyTemplatesAndBlueprintsPage } from '@confluence/site-settings/entry-points/TemplatesAndBlueprintsPage.ts';
import { ADMIN_MIGRATION_TEMPLATES_AND_BLUEPRINTS_ANALYTICS_SOURCE } from '@confluence/site-settings/entry-points/templatesAndBlueprintsConstants.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const AdminTemplatesAndBlueprintsRoute = () => <LazyTemplatesAndBlueprintsPage />;

AdminTemplatesAndBlueprintsRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: ADMIN_MIGRATION_TEMPLATES_AND_BLUEPRINTS_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
